export const STEP_1 = 1;
export const STEP_2 = 2;
export const STEP_3 = 3;

export const MAX_COMPANY_SHORT_NAME_LENGTH = 50;
export const MAX_COMPANY_FULL_NAME_LENGTH = 255;
export const MAX_COMPANY_NAME_LENGTH = 50;
export const MAX_REGISTRATION_NUMBER_LENGTH = 15;
export const MAX_LICENSE_NUMBER_LENGTH = 20;
export const MAX_YEARS_IN_BUSINESS_LENGTH = 3;
export const MAX_INDUSTRIES_LENGTH = 12;
export const MAX_FULL_NAME_LENGTH = 100;
export const MAX_DEBIT_CARD_NAME_LENGTH = 19;
export const MIN_DEBIT_CARD_NAME_LENGTH = 1;
export const MIN_MOTHER_NAME_LENGTH = 3;
export const MAX_MOTHER_MAIDEN_NAME_LENGTH = 30;

export const COMPANY_INFO_PAGE_ID = "companyInfo";

export const COUNTRY_CODE_UAE = "AE";

export const blackListedAuthoritiesForUAE = {
  OS: { code: "OS", displayText: "Overseas", key: "OS", subGroup: null, value: "OS" },
  RAKE: { code: "RAKE", displayText: "RAKICC", key: "RAKE", subGroup: null, value: "RAKE" }
};
// eslint-disable-next-line max-len
export const REGEX_LLC_PATTERN = /(?:Limited Liability Company)|((?:LLC)|(?:L\.L\.C\.?)|(?:llc)|(?:L L C))/i;

export const MAX_FIRST_NAME_LENGTH = 30;

export const MAX_LAST_NAME_LENGTH = 30;

export const MAX_MIDDLE_NAME_LENGTH = 30;

export const MAX_CHEQUE_BOOK_NAME_LENGTH = 50;

export const NO_OF_EMPLOYEE_DATALIST_ORDER_BY = [
  "No Employees",
  "1-9",
  "10-25",
  "26-50",
  "51-100",
  "101-200",
  "Greater than 200"
];

export const MAX_COMPANY_WEBSITE_LENGTH = 150;

export const COMPANY_CATEGORY_SEND_INVITE_OPTIONS_ORDER = ["MP", "MPLL", "SP", "SPLL", "ONBEHALF"];
export const MAX_RETRY_COUNT = 3;
export const RAKEZ_AUTHORITY_CODE = "rake";
export const SINGLE_PERSONA = "SP";
export const MULTIPLE_PERSONA = "MP";
export const licenseErrorMessages = [
  "No license details found for the given License Number.",
  "License Number is missing or empty in the request.",
  "License Number format is invalid."
];
export const LICENSE_NO_ERROR_TITLE = "We couldn't verify your trade licence";
export const LICENSE_NO_ERROR_SUBTITLE =
  "Please reupload your document or enter your licence number manually.";
export const TL_FETCH_COMMON_ERROR_TITLE = "We are unable to fetch the data currently";
export const TL_FETCH_COMMON_ERROR_SUBTITLE = "Do you want to retry or fill the data manually?";
